import type { AccountFeatureFlag, UUID } from 'interfaces';
import type { Store } from 'redux';
import createStoreObserver from 'redux-store-observer';
import configureStore from './store';

const initialState = {};

export const store: Store<IStoreShape> = configureStore(initialState);

export const storeObserver = createStoreObserver(store);

export type AppDispatch = typeof store.dispatch;
// Each time you convert a selector to TS, it would be wise to add the state here.
export interface IStoreShape {
  home: Map<string, IHome>;
  publicLanding: Map<string, IPublicLanding>;
}

export interface IHome extends AccountFeatureFlag {
  accountId: number;
  accountName: string;
  authMethod: string;
  error?: unknown;
  isEnterprise: boolean;
  permissions: number[];
  roleId: number;
  roleName: string;
  user: IUser;
  aIAssistantAppLimit: number;
}

export interface IPublicLanding {
  loading: boolean;
  projectTeam: {
    pub_team_uuid?: string;
    module_name?: string;
    has_security_code?: boolean;
  };
  error: Record<string, unknown>;
}

interface IUser {
  email: string;
  first: string;
  id: number;
  last: string;
  uuid: UUID;
}
